import { render, staticRenderFns } from "./CollaboratorActions.vue?vue&type=template&id=27f9380a"
import script from "./CollaboratorActions.vue?vue&type=script&lang=ts"
export * from "./CollaboratorActions.vue?vue&type=script&lang=ts"
import style0 from "./CollaboratorActions.vue?vue&type=style&index=0&id=27f9380a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports